import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { useLocale } from 'hooks/useLocale';
import { ProductsDE } from './ProductsDE/ProductsDE';
import { ProductsSkeleton } from './ProductsSkeleton/ProductsSkeleton';
import { ProductsUK } from './ProductsUK/ProductsUK';

export const Products = () => {
  const { isDE } = useLocale();
  const { isContextLoading, isIntroducerLoading } = useIntroducerData();

  if (isContextLoading || isIntroducerLoading) {
    return <ProductsSkeleton />;
  }

  if (!isDE) return <ProductsUK />;
  return <ProductsDE />;
};
